export const CriteriaCertificationTypeEnumValue = {
  RetailEnvironment: 1,
  ExteriorSignage: 2,
};

export const CriteriaCertificationTypeEnum = [
  {
    value: CriteriaCertificationTypeEnumValue.RetailEnvironment,
    name: 'RetailEnvironment',
    labelFrench: 'Environnement de vente au détail',
    labelEnglish: 'Retail Environment',
  },
  {
    value: CriteriaCertificationTypeEnumValue.ExteriorSignage,
    name: 'ExteriorSignage',
    labelFrench: 'Enseigne Extérieure',
    labelEnglish: 'Exterior Signage',
  },
];

export const getCriteriaCertificationType = criteriaCertificationType => {
  const numericValue = Number(criteriaCertificationType);
  if (Number.isNaN(numericValue)) {
    return null;
  }

  return CriteriaCertificationTypeEnum.find(type => type.value === numericValue) ?? null;
};

export default CriteriaCertificationTypeEnum;
